import BlogType from './BlogType'

const startupReducer = (state, action) => {
  switch (action.type) {
    case BlogType.GET_BLOGS:
      return {
        ...state,
        blogs: action.payload,
        loading: false,
      }
    case BlogType.GET_BLOG:
      return {
        ...state,
        blog: action.payload,
        loading: false,
      }
    case BlogType.CREATE_BLOG:
      return {
        ...state,
        blog: action.payload,
        loading: false,
      }
    case BlogType.UPDATE_BLOG:
      return {
        ...state,
        blog: action.payload,
        loading: false,
      }
    case BlogType.DELETE_BLOG:
      return {
        ...state,
        loading: false,
      }
    case 'SET_LOADING':
      return {
        ...state,
        loading: true,
      }
    default:
      return state
  }
}

export default startupReducer
